import { CandidatePageActions } from "../../candidatePageActions";

export const getCandidatesSearchCMSContent = async () => {
    try {
        const payload = { pagename: "Candidates" };
        const res = await CandidatePageActions.getAdminCandidateCMSContent(payload);

        if (res?.status === 200 || res?.status === 204) {
            const page = res?.data?.Pages?.find(
                (el) => el?.Key === "Candidates.CandidatesSearch"
            );

            if (!page) {
                return null;
            }

            const { Title, Description, TabNavigationTitle, Components } = page;
            return {
                title: Title,
                description: Description,
                tabNavigationTitle: TabNavigationTitle,
                pageContent: Components,
            };
        }

        return null;
    } catch (error) {
        return null;
    }
};
